import React from 'react';
import { SearchConfig } from '../../constants';
import './search.scss';
import { SearchBar } from '../search-bar';
import { ReactComponent as SearchIcon } from '@zonofi/svg-icons/search-icon.svg';
import { ReactComponent as BackIcon } from '@zonofi/svg-icons/arrow_left.svg';
import { dispatch, updateSearchKey } from '@zonofi/zono-money-store';

export interface SearchComponent {
  searchInput: {
    component: React.ReactNode;
    state: { showSearch: boolean; showSearchWindow: boolean };
  };
  searchResult: {
    component: React.ReactNode | undefined;
    state: { showSearchWindow: boolean };
  };
}
interface SearchProps {
  searchConfig: SearchConfig;
  setShowSearch: (val: boolean) => void;
  resetAll?: () => void;
}
export const searchComponents = ({
  searchConfig,
  setShowSearch,
  resetAll = () => {},
}: SearchProps): SearchComponent => {
  const {
    showWindow: showSearchWindow = false,
    setShowWindow: setShowSearchWindow,
    placeholderText = 'Search',
    onSearchAction,
    customElement: searchElement,
    results: searchResults,
    enabled: showSearch = false,
  } = searchConfig;

  const handleSearchEvent =
    (callback: () => void) => (e: React.SyntheticEvent) => {
      e.preventDefault();
      callback();
    };

  const handleEnterPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      // onSearchAction?.();
    }
  };

  return {
    searchInput: {
      component: (
        <div className={`search ${showSearch ? 'active' : ''}`}>
          {!showSearch ? (
            <SearchIcon
              color="#000000"
              onClick={() => {
                setShowSearch(true);
                resetAll();
              }}
            />
          ) : searchElement ? (
            searchElement
          ) : (
            <SearchBar
              leftIcon={<BackIcon color="#000" />}
              placeholderText={placeholderText}
              onLeftClick={onSearchAction}
              handleFocus={handleSearchEvent(() => setShowSearchWindow?.(true))}
              handleClick={handleSearchEvent(() => setShowSearchWindow?.(true))}
              handleClear={handleSearchEvent(() => {
                dispatch(updateSearchKey(''));
                setShowSearchWindow?.(false);
              })}
              handleEnterPress={handleEnterPress}
            />
          )}
        </div>
      ),
      state: { showSearch, showSearchWindow },
    },
    searchResult: {
      component: showSearchWindow && searchResults ? searchResults : undefined,
      state: { showSearchWindow },
    },
  };
};
